import { get, post, patch, del } from "aws-amplify/api";
import { v4 as uuidv4 } from "uuid";

import { 
  UpsertableBase,
  User,
  ModelBase,
  PlayerObject,
  SmartHash,
  FeatureSource,
  FloatingFeature,
  OptionalFeatureBase,
  // DisablableOption,
  TempHash,
  ArchivesHash,
  ArchivesTempHash,
  Subscription,
  OtherHash,
  ParentedBase,
  CreatureFeature
} from "@models";
import { 
  ACTION_TYPES,
  ARMOR_TYPES,
  Campaign, 
  CampaignChar, 
  CampaignCharOptions, 
  CampaignDeck, 
  CampaignObject, 
  CampaignPlayer, 
  CampaignPlayers, 
  Character, 
  CharacterOptions, 
  LANGUAGES, 
  SENSES, 
  SKILLS, 
  SourceBook,
  WEAPON_KEYWORDS
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
// import UserAPI from "./user_api";
import UserLogin from "@utilities/user_login";
import { 
  CONSTANTIZED_DATA_TYPES,
  OTHER_NON_CACHED_OBJECTS, 
  PLAYER_OBJECT_TYPES, 
  TRUST_JSON_FOR_DATA_TYPES 
} from "@dndModels/DataTypeConstants";
import { DATA_TYPE_INFO } from "@dndModels/Constants";
import { CampaignObjectType, DataType, isDataType, isPlayerObjectType, PlayerObjectType, WorldSetting } from "@dndModels/Types";
// import { CHARACTER_PIECES } from "../systems/d&d/models/Constants";

const myAPI = "hbldev";
// const use_amplify = true;
// const use_amplify = false;
// const use_api = true;

const delay = (milliseconds: number) => new Promise(res => setTimeout(res, milliseconds));

interface DataCall {
  path: string;
  data?: any;
  options?: any;
  system?: string;
}

const common_util = CommonUtilities.getInstance();

// Core API Calls
const getData = async ({ path, system = "main", options = {} }: DataCall): Promise<any> => {
  try {
    const response = await get({
      apiName: myAPI,
      path: `${path}/${system}`,
      options: options
    }).response;
    
    return await response.body.json();
  } catch (ex) {
    console.error(ex);
    console.error(`${path}/${system}`);
    console.error(options);
  }
  return { error: "Offline" };
};

const postData = async ({ path, data, system = "main", options = {} }: DataCall): Promise<any> => {
  try {
    const response = await post({
      apiName: myAPI,
      path: `${path}/${system}`,
      options: {
        body: data,
        ...options
      }
    }).response;
    
    return await response.body.json();
  } catch (ex) {
    console.error(ex);
    console.error(`${path}/${system}`);
    console.error(options);
  }
  return { error: "Offline" };
};

const uploadData = async ({ path, data, system = "main", options = {} }: DataCall): Promise<any> => {
  const response = await post({
    apiName: myAPI,
    path: `${path}/${system}`,
    options: {
      body: data,
      ...options
    }
  }).response;
  
  return await response.body.json();
};

const patchData = async ({ path, data, system = "main", options = {} }: DataCall): Promise<any> => {
  try {
    const response = await patch({
      apiName: myAPI,
      path: `${path}/${system}`,
      options: {
        body: data,
        ...options
      }
    }).response;
    
    return await response.body.json();
  } catch (ex) {
    debugger;
    console.error(ex);
    console.error(`${path}/${system}`);
    console.error(options);
  }
  return {};
};

const deleteData = async ({ path, data, system = "main", options = {} }: DataCall): Promise<any> => {
  const response = await del({
    apiName: myAPI,
    path: `${path}/${system}`,
    options: {
      body: data,
      ...options
    }
  }).response;
  
  return await response.body.json();
};

export const filter = (data_type: string, objects: any[], the_filter: any, log_it = false) => {
  try {
    // if (data_type === "magic_item_keyword") {
    //   log_it = true;
    //   debugger;
    // }
    let filtered = [...objects];
    if (log_it) {
      // debugger;
      console.log(filtered);
      console.log(Object.keys(the_filter));
      console.log(the_filter);
    }
    const keys = Object.keys(the_filter);
    for (const key of keys) {
      // if (key === "prof_type") {
      //   log_it = true;
      //   debugger;
      // }
      const value = the_filter[key];
      if (log_it) {
        console.log(key);
        console.log(value);
        console.log(filtered);
      }
      if (key === "search_string") {
        let search_string = "";
        if (typeof value === "object") {
          search_string = value[0];
        } else if (typeof value === "string") {
          search_string = value;
        }
        if (search_string.length > 0) {
          if (search_string.toLocaleLowerCase() === "nameless") {
            filtered = filtered.filter(o => 
              o.name.length === 0
            );
          } else {
            const pieces = search_string.split(" ");
            for (const piece of pieces) {
              filtered = filtered.filter(o => 
                o.name.toLowerCase().includes(piece.toLowerCase()) ||
                o.description.toLowerCase().includes(piece.toLowerCase())
              );
            }
          }
        }
      } else if (key.includes("*")) {
        const pieces = key.split("*");
        const new_key = pieces[0];
        const operation = pieces[1];
        if (operation === "in") {
          filtered = filtered.filter(o => 
            (typeof((o as any)[new_key]) === "object" && 
              (o as any)[new_key].length !== undefined && 
              common_util.anyOverlaps(value, (o as any)[new_key])
            ) ||
            ((typeof((o as any)[new_key]) !== "object" || 
              (o as any)[new_key].length === undefined) && 
              value.includes((o as any)[new_key])
            )
          );
        } else if (operation === "nin") {
          filtered = filtered.filter(o => 
            (typeof((o as any)[new_key]) === "object" && 
              (o as any)[new_key].length !== undefined && 
              !common_util.anyOverlaps((o as any)[new_key], value)
            ) ||
            ((typeof((o as any)[new_key]) !== "object" || 
              (o as any)[new_key].length === undefined) && 
              !value.includes((o as any)[new_key])
            )
          );
        } else {
          if (typeof(value) === "string") {
            if (operation === "includes") {
              filtered = filtered.filter(o => o[new_key].toLowerCase().includes(value.toLowerCase()));
            } else if (operation === "startsWith") {
              filtered = filtered.filter(o => o[new_key].toLowerCase().startsWith(value.toLowerCase()));
            } else if (operation === "ObjectIDs") {
              filtered = filtered.filter(o => value.includes(o[new_key]));
            } else if (operation === "ObjectID") {
              filtered = filtered.filter(o => value === o[new_key]);
            } else if (operation === "ObjectIDNot") {
              filtered = filtered.filter(o => value !== o[new_key]);
            }
          } else if (typeof(value) === "object" && value.length > 0) { // It's actually string[]
            const val_list: string[] = value;
            if (operation === "includes") {
              filtered = filtered.filter(o => val_list.find(o2 => o[new_key].toLowerCase().includes(o2.toLowerCase())) !== undefined);
            } else if (operation === "startsWith") {
              filtered = filtered.filter(o => val_list.find(o2 => o[new_key].toLowerCase().startsWith(o2.toLowerCase())) !== undefined);
            } else if (operation === "ObjectIDs") {
              filtered = filtered.filter(o => val_list.includes(o[new_key]));
            } else if (operation === "ObjectID") {
              filtered = filtered.filter(o => val_list.includes(o[new_key]));
            } else if (operation === "ObjectIDsNot") {
              filtered = filtered.filter(o => !val_list.includes(o[new_key]));
            } 
          }
        }
      } else if (key.includes(".")) {
        const pieces = key.split(".");
        const new_filtered: any[] = [];
        for (const obj of filtered) {
          let sub_obj = obj;
          for (const piece of pieces) {
            if (sub_obj[piece] !== undefined) {
              sub_obj = sub_obj[piece];
            } else {
              sub_obj = null;
              break;
            }
          }
          if (sub_obj !== undefined && sub_obj !== null) {
            if (typeof value === "object") {
              if (value["$in"]) {
                try {
                  const arr = value["$in"].map((o: any) => `${o}`);
                  if (arr.include(`${sub_obj}`)) {
                    new_filtered.push(obj);
                  }
                } catch (ex) {}
              } else if (value["in"]) {
                try {
                  const arr = value["in"].map((o: any) => `${o}`);
                  if (arr.include(`${sub_obj}`)) {
                    new_filtered.push(obj);
                  }
                } catch (ex) {}
              } else if (value["$nin"]) {
                try {
                  const arr = value["$nin"].map((o: any) => `${o}`);
                  if (!arr.include(`${sub_obj}`)) {
                    new_filtered.push(obj);
                  }
                } catch (ex) {}
              } else if (value["nin"]) {
                try {
                  const arr = value["nin"].map((o: any) => `${o}`);
                  if (!arr.include(`${sub_obj}`)) {
                    new_filtered.push(obj);
                  }
                } catch (ex) {}
              } else if (value["$not"]) {
                if (value["$not"] !== sub_obj) {
                  new_filtered.push(obj);
                }
              } else if (value["not"]) {
                if (value["not"] !== sub_obj) {
                  new_filtered.push(obj);
                }
              } else if (value["gte"]) {
                if (sub_obj >= value["gte"]) {
                  new_filtered.push(obj);
                }
              } else if (value["$gte"]) {
                if (sub_obj >= value["$gte"]) {
                  new_filtered.push(obj);
                }
              } else if (value["lte"]) {
                if (sub_obj <= value["lte"]) {
                  new_filtered.push(obj);
                }
              } else if (value["$lte"]) {
                if (sub_obj <= value["$lte"]) {
                  new_filtered.push(obj);
                }
              } else {
                console.log("Not Implemented");
                console.log(key);
                console.log(value);
                console.log(filtered);
              }
            } else {
              if (value === sub_obj) {
                new_filtered.push(obj);
              }
            }
          }
        }
        filtered = new_filtered;
      } else {
        if (typeof value === "object") {
          if (log_it) {
            console.log(value);
            console.log(value.length);
            console.log(value["$in"]);
            console.log(filtered);
            if (filtered.length > 0) {
              console.log((filtered[0] as any)[key]);
              if (value["$in"]) {
                console.log(value["$in"].includes((filtered[0] as any)[key]));
              }
            }
          }
          if (value.length) {
            if (key === "$or") {
              const new_filtered: (ModelBase | User)[] = [];
              for (const new_filter of value) {
                const results = filter(data_type, [...filtered], new_filter);
                for (const r of results) {
                  if (new_filtered.filter(o => o.id === r.id).length === 0) {
                    new_filtered.push(r);
                  }
                }
              }
              filtered = new_filtered;
            } else if (key === "or") {
              const new_filtered: (ModelBase | User)[] = [];
              for (const new_filter of value) {
                const results = filter(data_type, [...filtered], new_filter);
                for (const r of results) {
                  if (new_filtered.filter(o => o.id === r.id).length === 0) {
                    new_filtered.push(r);
                  }
                }
              }
              filtered = new_filtered;
            } else if (key === "$and") {
              let new_filtered: (ModelBase | User)[] = filter(data_type, [...filtered], value[0])
              for (let i = 1; i < value.length; ++i) {
                const new_filter = value[i];
                const results = filter(data_type, [...filtered], new_filter);
                const ids = results.map(o => o.id);
                new_filtered = new_filtered.filter(o => ids.includes(o.id));
              }
              filtered = new_filtered;
            } else if (key === "and") {
              let new_filtered: (ModelBase | User)[] = filter(data_type, [...filtered], value[0])
              for (let i = 1; i < value.length; ++i) {
                const new_filter = value[i];
                const results = filter(data_type, [...filtered], new_filter);
                const ids = results.map(o => o.id);
                new_filtered = new_filtered.filter(o => ids.includes(o.id));
              }
              filtered = new_filtered;
            } else {
              console.log("Not Implemented");
              console.log(key);
              console.log(value);
              console.log(filtered);
            }
          } else {
            if (value["$in"] !== undefined) {
              // debugger;
              if (log_it) {
                console.log(value);
                console.log(key);
                console.log(filtered);
                // if (filtered.length > 0 && filtered[0] instanceof OptionalFeatureBase) {
                //   console.log(filtered.filter(o => o.name.includes("Psionic")));
                // }
              }
              if (typeof(value["$in"]) === "object" && value["$in"].length !== undefined) {
                filtered = filtered.filter(o => 
                  (typeof((o as any)[key]) === "object" && 
                    (o as any)[key].length !== undefined && 
                    common_util.anyIncludes2(value["$in"], (o as any)[key])
                  ) ||
                  ((typeof((o as any)[key]) !== "object" || 
                    (o as any)[key].length === undefined) && 
                    value["$in"].includes((o as any)[key])
                  )
                );
              } else {
                filtered = filtered.filter(o => 
                  (typeof((o as any)[key]) === "object" && 
                    (o as any)[key].length !== undefined && 
                    common_util.anyIncludes(value["$in"], (o as any)[key])
                  ) ||
                  ((typeof((o as any)[key]) !== "object" || 
                    (o as any)[key].length === undefined) && 
                    value["$in"].includes((o as any)[key])
                  )
                );
              }
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["in"] !== undefined) {
              // debugger;
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  common_util.anyOverlaps(value["in"], (o as any)[key])
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  value["in"].includes((o as any)[key])
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["$nin"] !== undefined) {
              // debugger;
              if (log_it) {
                console.log(filtered);
                for (const obj of filtered) {
                  console.log(obj);
                  console.log((obj as any)[key]);
                }
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  !common_util.anyOverlaps((o as any)[key], value["$nin"])
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  !value["$nin"].includes((o as any)[key])
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["nin"] !== undefined) {
              // debugger;
              if (log_it) {
                console.log(filtered);
                for (const obj of filtered) {
                  console.log(obj);
                  console.log((obj as any)[key]);
                }
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  !common_util.anyOverlaps((o as any)[key], value["nin"])
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  !value["nin"].includes((o as any)[key])
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["$not"] !== undefined) {
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  !(o as any)[key].includes(value["$not"])
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  value["$not"] !== (o as any)[key]
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["not"] !== undefined) {
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  !(o as any)[key].includes(value["not"])
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  value["not"] !== (o as any)[key]
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["gte"] !== undefined) {
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  (o as any)[key].filter((o2: number) => o2 >= value["gte"]).length > 0
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  (o as any)[key] >= value["gte"]
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["$gte"] !== undefined) {
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  (o as any)[key].filter((o2: number) => o2 >= value["$gte"]).length > 0
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  (o as any)[key] >= value["$gte"]
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["lte"] !== undefined) {
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  (o as any)[key].filter((o2: number) => o2 <= value["lte"]).length > 0
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  (o as any)[key] <= value["lte"]
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            if (value["$lte"] !== undefined) {
              if (log_it) {
                console.log(filtered);
              }
              filtered = filtered.filter(o => 
                (typeof((o as any)[key]) === "object" && 
                  (o as any)[key].length !== undefined && 
                  (o as any)[key].filter((o2: number) => o2 <= value["$lte"]).length > 0
                ) ||
                ((typeof((o as any)[key]) !== "object" || 
                  (o as any)[key].length === undefined) && 
                  (o as any)[key] <= value["$lte"]
                )
              );
              if (log_it) {
                console.log(filtered);
              }
            }
            const obj_keys = Object.keys(value).filter(o => !["$in","in","$nin","nin","$not","not","gte","$gte","lte","$lte","id"].includes(o));
            if (obj_keys.length > 0) {
              console.error("Not Implemented");
              console.error(data_type);
              console.error(key);
              console.error(value);
              console.error(obj_keys);
            }
          }
        } else {
          if (value === "**EMPTY**") {
            filtered = filtered.filter(o => 
              (typeof((o as any)[key]) === "object" && 
                (o as any)[key].length !== undefined && 
                (o as any)[key].filter((o2: any) => o2.length === 0).length > 0
              ) ||
              ((typeof((o as any)[key]) !== "object" || 
                (o as any)[key].length === undefined) && 
                (o as any)[key].length === 0
              )
            );
          } else {
            if (log_it) {
              debugger;
            }
            filtered = filtered.filter(o => 
              (typeof((o as any)[key]) === "object" && 
                (o as any)[key].length !== undefined && 
                (o as any)[key].includes(value)
              ) ||
              ((typeof((o as any)[key]) !== "object" || 
                (o as any)[key].length === undefined) && 
                value === (o as any)[key]
              )
            );
          }
          // filtered = filtered.filter(o => (Array.isArray((o as any)[key]) && (o as any)[key].includes(value)) || (!Array.isArray((o as any)[key]) && (o as any)[key] === value));
        }
        if (log_it) {
          console.log(filtered);
        }
      }
    }
    if (log_it) {
      console.log(filtered);
    }
    return filtered;
  } catch (ex) {
    console.error(ex);
    debugger;
    return objects;
  }
};

// Helper function to batch promises with progress callback
async function batchPromises<T>(
  items: T[], 
  batchSize: number, 
  processItem: (item: T) => Promise<any>,
  onBatchComplete?: (completedCount: number, totalCount: number) => void
): Promise<any[]> {
  const results: any[] = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchResults = await Promise.all(batch.map(processItem));
    results.push(...batchResults);
    
    // Call progress callback after each batch
    if (onBatchComplete) {
      onBatchComplete(i + batch.length, items.length);
    }
  }
  return results;
}

export class SmartAPIClass {
  apis: { [name: string]: APIClass } = {};
  currentSystem = "";

  // smart_hash: SmartHash = {};
  // old_hash: SmartHash = {};
  string_suggestions: { data_type: DataType, field: string, suggestions: string[] }[] = [];
  // search_string: string = "";
  // filters: { [field: string]: string } = {};
  // user_login = UserLogin.getInstance();

  // get user(): User | null {
  //   return this.user_login.user;
  // }

  // set user(user: User | null) {
  //   this.user_login.user = user;
  // }

  // set true_user(user: User | null) {
  //   this.user_login.true_user = user;
  //   this.user_login.user = user;
  // }

  getSetOfObjectsForSystem = async ({
    system, 
    data_types, 
    filter = {}, 
    filters = {}, 
    refresh = false,
    log_it = false
  }: {
    system: string, 
    data_types: DataType[], 
    filter?: any, 
    filters?: any, 
    refresh?: boolean,
    log_it?: boolean
  }) => {
    if (log_it) {
      debugger;
    }
    if (this.apis[system]) {
      if (log_it) {
        debugger;
      }
      return await this.apis[system].getSetOfObjects({ data_types, filter, filters, refresh, log_it });
    } else {
      return {};
    }
  };

  // getObjectsForSystem = async ({
  //   system,
  //   data_type,
  //   filter = {}, 
  //   refresh = false,
  //   ignore_templates = true,
  //   archives = [],
  //   log_it = false
  // }: {
  //   system: string, 
  //   data_type: DataType, 
  //   filter?: any, 
  //   refresh?: boolean,
  //   ignore_templates?: boolean,
  //   archives?: string[],
  //   log_it?: boolean
  // }) => {
  //   if (this.apis[system]) {
  //     return await this.apis[system].getObjects({ data_type, filter, refresh, ignore_templates, archives, log_it });
  //   } else {
  //     return [];
  //   }
  // };

  getObjectFieldValuesForSystem = async (system: string, data_type: DataType, 
    field: string, filter: any = {}, refresh = false) => {
    if (this.apis[system]) {
      return await this.apis[system].getObjectFieldValues(data_type, field, filter, refresh);
    } else {
      return [];
    }
  };
  getSetOfObjectsWithCallbacksForSystem = async ({ 
    system,
    data_types, 
    filter = {}, 
    filters = {}, 
    refresh = false,
    force_api = false,
    force_json = false,
    onComplete,
    onProgress,
    onError
  }: { 
    system: string, 
    data_types: DataType[], 
    filter?: any, 
    filters?: any, 
    refresh?: boolean,
    force_api?: boolean,
    force_json?: boolean,
    onComplete?: (res: SmartHash) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
    onError?: Function,
  }) => {
    if (this.apis[system]) {
      return await this.apis[system].getSetOfObjectsWithCallbacks({ data_types, filter, filters, refresh, force_api, force_json, onProgress, onComplete, onError });
    } else {
      return [];
    }
  };
  // getObjectsWithCallbacksForSystem = async ({
  //   system,
  //   data_type, 
  //   filter = {}, 
  //   refresh = false,
  //   force_api = false,
  //   force_json = false,
  //   onComplete,
  //   onProgress,
  //   onError,
  //   archives = [],
  //   // character_options,
  //   log_it = false
  // }: {
  //   system: string, 
  //   data_type: DataType, 
  //   filter?: any, 
  //   refresh?: boolean,
  //   force_api?: boolean,
  //   force_json?: boolean,
  //   onComplete?: (res: ModelBase[]) => void,
  //   onProgress?: (data_type: DataType, percentage: number) => void,
  //   onError?: Function,
  //   archives?: string[],
  //   // character_options?: CharacterOptions,
  //   log_it?: boolean
  // }): Promise<ModelBase[]> => {
  //   // debugger;
  //   if (this.apis[system]) {
  //     return await this.apis[system].getObjectsWithCallbacks({ data_type, filter, refresh, force_api, force_json, archives, onProgress, onComplete, onError, log_it });
  //   } else {
  //     return [];
  //   }
  // };

  createObjectForSystem = async (system: string, data_type: DataType, obj: UpsertableBase) => {
    if (this.apis[system]) {
      return await this.apis[system].createObject(data_type, obj);
    } else {
      return { body: { error: "No System" }, res: null };
    }
  };

  deleteObjectForSystem = async (system: string, data_type: DataType, obj: UpsertableBase) => {
    if (this.apis[system]) {
      return await this.apis[system].deleteObject(data_type, obj);
    } else {
      return [];
    }
  };
  
  filter = (data_type: string, objects: any[], the_filter: any, log_it = false) => {
    return filter(data_type, objects, the_filter, log_it);
  };
}

export interface RoutePath {
  path: string;
  name: string;
}

declare const __APP_VERSION__: string;

export abstract class APIClass {
  version = __APP_VERSION__;
  system = "";
  online = true;
  smart_hash: SmartHash = {};
  archives_smart_hash: ArchivesHash = {};
  temp_hash: TempHash = {};
  archives_temp_hash: ArchivesTempHash = {};
  use_temp_hash = true;
  other_hash: OtherHash = new OtherHash();
  calling: string[] = [];
  string_suggestions: { field: string, suggestions: string[] }[] = [];
  search_string = "";
  filters: { [field: string]: string[] } = { is_dominant: ["True"], sidekick: ["False"], common: ["True"] };
  excludes: string[] = [];
  working_on_sb: SourceBook | null = null;
  working_on_setting: WorldSetting | "" = "";
  working_on_tags: string[] = [];
  working_on_object: { data_type: DataType | "", [field: string]: string } = { data_type: "" };
  recipes_for_campaign: Campaign | null = null;
  user_login = UserLogin.getInstance();
  temp_hash_interval: any = null;
  subscription_holder: RootSubscriptionHolder = new RootSubscriptionHolder();

  applyWorkingOn<T extends ModelBase>(object: T): T {
    if (object instanceof SourceBook) {
      // Do nothing
    } else {
      if (this.working_on_sb) {
        object.source_books = [this.working_on_sb];
        object.source_books_old = [{ id: this.working_on_sb._id, type: this.working_on_sb.source_book_type, third_party: this.working_on_sb.third_party }];
      }
      if (this.working_on_setting !== "") {
        object.world_settings = [this.working_on_setting];
      }
      object.tags = common_util.unique_array([...object.tags,...this.working_on_tags]);
      if (this.working_on_object.data_type !== "" && Object.keys(this.working_on_object).length > 1) {
        const obj_as_any = object as any;
        for (const key of Object.keys(this.working_on_object)) {
          if (key !== "data_type") {
            const value = this.working_on_object[key];
            if (obj_as_any[key] !== undefined) {
              if (typeof obj_as_any[key] === "number") {
                obj_as_any[key] = +value;
              } else if (typeof obj_as_any[key] === "string") {
                obj_as_any[key] = value;
              } else if (typeof obj_as_any[key] === "object") {
                if (obj_as_any[key].length !== undefined) {
                  try {
                    // It might be a string array
                    obj_as_any[key] = [value];
                  } catch (ex) {
                    obj_as_any[key] = [];
                  }
                }
              }
            }
          }
        }
      }
    }
    return object;
  }

  check_temp_hash() {
    // console.log(this.temp_hash_interval);
    // console.log(this.temp_hash);
    // console.log(this.archives_temp_hash);
    if (this.user && this.user.admin) {
      // Leave Temp Hash intact when in admin mode
    } else {
      const five_minutes_ago = common_util.get_time_number() - 500;
      // console.log(five_minutes_ago);
      let data_types = Object.keys(this.temp_hash);
      for (const data_type of data_types) {
        if (this.temp_hash[data_type].last_accessed < five_minutes_ago) {
          delete this.temp_hash[data_type];
        }
      }
      let clear_it = Object.keys(this.temp_hash).length === 0;
      const archived_sb_ids = Object.keys(this.archives_temp_hash);
      for (const archived_sb_id of archived_sb_ids) {
        data_types = Object.keys(this.archives_temp_hash[archived_sb_id]);
        for (const data_type of data_types) {
          if (this.archives_temp_hash[archived_sb_id][data_type].last_accessed < five_minutes_ago) {
            delete this.archives_temp_hash[archived_sb_id][data_type];
          }
        }
        if (clear_it) {
          clear_it = Object.keys(this.archives_temp_hash[archived_sb_id]).length === 0;
        }
      }
      if (clear_it) {
        clearInterval(this.temp_hash_interval);
        this.temp_hash_interval = null;
        // console.log(this.temp_hash_interval);
      }
    }
  }

  store_to_temp(data_type: DataType, objects: ModelBase[], archived_sb_id = "") {
    if (this.use_temp_hash) {
      if (archived_sb_id === "") {
        this.temp_hash[data_type] = { objects, last_accessed: common_util.get_time_number() };
        if (this.temp_hash_interval === null) {
          this.temp_hash_interval = setInterval(() => {
            this.check_temp_hash();
          }, 10000);
          // console.log(this.temp_hash_interval);
        }
      } else {
        this.archives_temp_hash[archived_sb_id][data_type] = { objects, last_accessed: common_util.get_time_number() };
        if (this.temp_hash_interval === null) {
          this.temp_hash_interval = setInterval(() => {
            this.check_temp_hash();
          }, 10000);
          // console.log(this.temp_hash_interval);
        }
      }
    }
  }

  get user(): User | null {
    return this.user_login.user;
  }

  set user(user: User | null) {
    this.user_login.user = user;
  }

  get true_user() {
    return this.user_login.true_user;
  }

  set true_user(user: User | null) {
    this.user_login.true_user = user;
    this.user_login.user = user;
  }

  get spoofing() {
    return this.user_login.spoofing;
  }

  get source_books() {
    return this.smart_hash.source_book ? this.smart_hash.source_book as SourceBook[] : [];
  }

  get user_source_books() {
    const sbs = this.source_books;
    if (this.user && sbs.length > 0) {
      const sb_ids = this.user.source_book_ids;
      return sbs.filter(o => sb_ids.includes(o._id));
    }
    return [];
  }
    
  get_filter(field: string): any {
    let filter: any = this.filters[field];
    if (filter) {
      if (this.excludes.includes(field)) {
        filter = { "$nin": filter };
      } else {
        filter = { "$in": filter };
      }
      return filter;
    } else {
      return {};
    }
  }
    
  get_filter2(field: string): any {
    let filter: any = this.filters[field];
    if (filter) {
      if (this.excludes.includes(field)) {
        filter = { "$nin": filter };
      } else {
        filter = { "$in": filter };
      }
      return filter;
    } else {
      if (this.excludes.includes(field)) {
        return "**EMPTY**";
      }
      return {};
    }
  }
  
  set_filter(field: string, values: string[]) {
    if (field === "search_string") {
      this.search_string = values[0];
    } else if (values.length === 0) {
      delete this.filters[field];
      this.set_exclude(field, false);
    } else {
      this.filters[field] = values;
    }
  }
    
  get_exclude(field: string): boolean {
    return this.excludes.includes(field);
  }
  
  set_exclude(field: string, value: boolean) {
    if (value) {
      this.excludes.push(field);
    } else {
      this.excludes = this.excludes.filter(o => o !== field);
    }
  }
    
  get_filters(): any {
    const filters: any = {...this.filters};
    const keys = Object.keys(this.excludes);
    for (const key of keys) {
      filters[key] = { "$nin": filters[key] };
    }
    return filters;
  }
  
  // Get Source Books
  getSourceBooks = async ({
    filter = {}, 
    refresh = false,
    onComplete,
    onProgress,
    log_it = false
  }: {
    filter?: any, 
    refresh?: boolean,
    onComplete?: (res: ModelBase[]) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
    log_it?: boolean
  }) => {
    if (log_it) {
      debugger;
    }
    if (refresh || !this.smart_hash.source_book) {
      await this.getSourceBooksFromAPI({ onProgress });
    }
    if (this.smart_hash.source_book) {
      let response = this.filter("source_book", this.smart_hash.source_book, filter) as SourceBook[];
      if (!this.user || !(this.user.view_blocked_source_books || this.user.admin)) {
        response = response.filter(o => !o.blocked);
      }
      if (onComplete) {
        onComplete(response);
      }
      return response;
    }
    return [] as SourceBook[];
  };
  getSourceBooksFromAPI = async ({
    // onComplete,
    onProgress,
    // onError,
  }: {
    // onComplete?: (res: PlayerObject[] | ModelBase[]) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
    // onError?: Function,
  }) => {
    const data_type = "source_book";
    let data: SourceBook[] = [];
    
    if (this.online) {
      let json_successful = false;
      if (!this.user || !this.user.admin) {
        if (!isPlayerObjectType(data_type)) {
          const new_objects = await this.readJson(data_type);
          if (new_objects) {
            json_successful = true;
            data = await this.processResponse2({ all: new_objects, data_type }) as SourceBook[];
          }
        }
      }
      if (!json_successful) {
        const count = await this.getObjectCountFromAPI({data_type, filter: { source_type: { $nin: ["Homebrew"] }, source_book_type: { $nin: ["Homebrew"] } }});
        const all: any[] = [];
        const piece_size = 200;
        
        let last_added = -1;
        while (all.length < count.count && last_added !== 0) {
          if (onProgress) {
            onProgress(data_type, all.length / count.count);
          }
          last_added = 0;
          const response = await this.getObjectsFromAPI2({data_type, filter: { source_type: { $nin: ["Homebrew"] }, source_book_type: { $nin: ["Homebrew"] } }, skip: all.length, take: piece_size});
          let body = response;
          if (body && !body.error && !body.message) {
            if (body.objects) {
              body = body.objects;
            }
            for (let i = 0; i < body.length; ++i) {
              const obj = body[i];
              if (all.filter(o => o._id === obj._id).length === 0) {
                all.push(obj);
                last_added++;
              }
            }
            // all = [...all,...body.objects];
          } else {
            console.log(response);
            console.log(body);
          }
        }
        data = await this.processResponse2({ all, data_type }) as SourceBook[];
      }
      if (this.user) {
        if (this.user.admin) {
          const count = await this.getObjectCountFromAPI({data_type, filter: { $or: [{ source_type: "Homebrew" }, { source_book_type: "Homebrew" }] }});
          const all: any[] = [];
          const piece_size = 200;
          // for (let i = 0; i < count.count; i += piece_size) {
          let last_added = -1;
          while (all.length < count.count && last_added !== 0) {
            if (onProgress) {
              onProgress(data_type, all.length / count.count);
            }
            last_added = 0;
            const response = await this.getObjectsFromAPI2({data_type, filter: { $or: [{ source_type: "Homebrew" }, { source_book_type: "Homebrew" }] }, skip: all.length, take: piece_size});
            let body = response;
            if (body && !body.error && !body.message) {
              if (body.objects) {
                body = body.objects;
              }
              for (let i = 0; i < body.length; ++i) {
                const obj = body[i];
                if (all.filter(o => o._id === obj._id).length === 0) {
                  all.push(obj);
                  last_added++;
                }
              }
              // all = [...all,...body.objects];
            } else {
              console.log(response);
              console.log(body);
            }
          }
          const newData = await this.processResponse2({ all, data_type, merge_hash: true }) as SourceBook[];
          data = [...data,...newData.filter(o => data.filter(o2 => o2._id === o._id).length === 0)];
        } else {
          const filter: any = {};
          const sand: any[] = [];
          sand.push({ "$or": [{ source_type: "Homebrew" }, { source_book_type: "Homebrew" }] });
          const owner_id: any = {};
          const is_public: any = {};
          owner_id["owner_id"] = this.user._id;
          is_public["public"] = true;
          sand.push({ "$or": [owner_id, is_public] });
          filter["$and"] = sand;
          const count = await this.getObjectCountFromAPI({data_type, filter});
          const all: any[] = [];
          const piece_size = 200;
          let last_added = -1;
          while (all.length < count.count && last_added !== 0) {
            if (onProgress) {
              onProgress(data_type, all.length / count.count);
            }
            last_added = 0;
            const response = await this.getObjectsFromAPI2({data_type, filter, skip: all.length, take: piece_size});
            let body = response;
            if (body && !body.error && !body.message) {
              if (body.objects) {
                body = body.objects;
              }
              for (let i = 0; i < body.length; ++i) {
                const obj = body[i];
                if (all.filter(o => o._id === obj._id).length === 0) {
                  all.push(obj);
                  last_added++;
                }
              }
            } else {
              console.log(response);
              console.log(body);
            }
          }
          const newData = await this.processResponse2({ all, data_type, merge_hash: true }) as SourceBook[];
          data = [...data,...newData.filter(o => data.filter(o2 => o2._id === o._id).length === 0)];
        }
        // this.user.source_book_ids = data.map(o => o._id);
      }
    }
    return data;
  };

  get_public_source_books(): SourceBook[] {
    return this.smart_hash.source_book.filter(o => 
      o instanceof SourceBook && o.is_free) as SourceBook[];
  }

  get_public_source_book_ids(): string[] {
    return this.get_public_source_books().map(sb => {
      return sb._id;
    });
  }

  get all_floating_features(): FloatingFeature[] {
    return this.smart_hash['floating_feature'] as FloatingFeature[];
  }
  
  add_floating_feature = async (ff: FloatingFeature) => {
    if (ff.data_type === "creature_feature") {
      const existing = this.get_creature_feature(ff._id);
      if (!existing) {
        this.smart_hash.creature_feature.push(ff);
      }
    } else {
      const existing = this.get_floating_feature(ff._id);
      if (!existing) {
        this.smart_hash.floating_feature.push(ff);
      }
    }
  }
  
  add_creature_feature = async (floating_feature: CreatureFeature) => {
    const existing = this.get_creature_feature(floating_feature._id);
    if (!existing) {
      this.smart_hash.creature_feature.push(floating_feature);
    }
  }

  get_creature_feature = (id: string) => {
    const ff = this.smart_hash.creature_feature ? this.smart_hash.creature_feature.find(o => 
      o instanceof CreatureFeature && (o._id === id || o.merged_ids.includes(id))) : null;
    if (ff instanceof CreatureFeature) {
      return ff;
    }
    return null;
  }

  get_floating_feature = (id: string) => {
    const ff = this.smart_hash.floating_feature ? this.smart_hash.floating_feature.find(o => 
      o instanceof FloatingFeature && (o._id === id || o.merged_ids.includes(id))) : null;
    if (ff instanceof FloatingFeature) {
      return ff;
    }
    return null;
  }

  getCForFF = (id: string) => {
    let ff: FloatingFeature | null = this.get_creature_feature(id);
    if (!ff) {
      ff = this.get_floating_feature(id);
    }
    return ff;
  }

  abstract to_floating_feature(obj: any): FloatingFeature;

  abstract newObjectOfType(data_type: DataType): ModelBase;
  
  getCampaign = async ({
    campaign_id,
    filter: param_filter,
    include = [],
    onComplete,
    onProgress,
  }: {
    campaign_id?: string,
    filter?: any,
    include?: string[],
    onComplete?: (res: Campaign) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
  }): Promise<Campaign | undefined> => {
    if (campaign_id || param_filter) {
      const campaign = await this.getPlayerObject<Campaign>({ data_type: "campaign", filter: param_filter, id: campaign_id, onProgress });
      if (campaign) {
        if (false) { // this.user && campaign.owner_id === this.user._id) {
          // campaign.owner = this.user;
        } else {
          campaign.owner = await this.getFullObject<User>("user", campaign.owner_id);
        }
        // Load the options. We always want this. It's just kept separate for ease of saving without screwing things up.
        campaign.char_options = await this.getCampaignObject<CampaignCharOptions>({ data_type: "campaign_char_options", campaign });
        // Load the containers for these, but only get the actual stuff for them as needed.
        await this.loadCPlayers({ campaign, include_players: include.includes("players") });
        await this.loadCChars({ campaign, include_players: include.includes("players"), include_chars: include.includes("characters") });
        // Load these as needed
        // campaign.c_decks = await this.getCampaignObjects<CampaignDeck>({ data_type: "campaign_deck", campaign_id });
        // campaign.encounters
        // campaign.notes
        // campaign.npcs
        // Not Currently Implemented. Not sure if I'll bring it back.
        // campaign.campaign_recipes 
        if (onComplete) {
          onComplete(campaign);
        }
        return campaign;
      }
    }
    return undefined;
  };
  loadCPlayers = async ({
    campaign,
    include_players = false,
  }: {
    campaign: Campaign,
    include_players?: boolean,
  }) => {
    if (!campaign.c_players) {
      campaign.c_players = await this.getCampaignObject<CampaignPlayers>({ data_type: "campaign_players", campaign });
    }
    if (campaign.c_players) {
      campaign.c_players.players = await this.getCampaignObjects<CampaignPlayer>({ data_type: "campaign_player", campaign });
      if (include_players) {
        for (const c_player of campaign.c_players.players) {
          c_player.player = await this.getFullObject<User>("user", c_player.player_id);
        }
      }
    }
  };
  loading_c_chars_for_campaigns: string[] = [];
  loadCChars = async ({
    campaign,
    include_players = false,
    include_chars = false,
  }: {
    campaign: Campaign,
    include_players?: boolean,
    include_chars?: boolean,
  }) => {
    if (!this.loading_c_chars_for_campaigns.includes(campaign._id)) {
      this.loading_c_chars_for_campaigns.push(campaign._id);
      if (campaign.c_chars.length === 0) {
        campaign.c_chars = await this.getCampaignObjects<CampaignChar>({ data_type: "campaign_char", campaign });
      }
      if (include_chars) {
        for (const c_char of campaign.c_chars) {
          if (!c_char.char) {
            c_char.char = await this.getPlayerObject<Character>({ data_type: "character", id: c_char.char_id });
          }
          if (c_char.char) {
            c_char.char.c_char = c_char;
            if (!c_char.char.owner && c_char.char.owner_id !== "" && include_players) {
              const player_id = c_char.char.owner_id;
              if (player_id === campaign.owner_id) {
                c_char.char.owner = campaign.owner;
              } else {
                c_char.char.owner = campaign.players.find(o => o._id === player_id);
                if (!c_char.char.owner) {
                  await this.loadCPlayers({ campaign, include_players });
                  c_char.char.owner = campaign.players.find(o => o._id === player_id);
                }
              }
            }
          }
        }
      }
      this.loading_c_chars_for_campaigns = this.loading_c_chars_for_campaigns.filter(o => o !== campaign._id);
    } else {
      while (this.loading_c_chars_for_campaigns.includes(campaign._id)) {
        await delay(1000);
      }
    }
  };
  getCampaignObjects = async <T extends CampaignObject>({
    data_type,
    campaign_id = "", 
    campaign,
    filter: param_filter,
    // force_api = false,
    onComplete,
    onProgress,
  }: {
    data_type: CampaignObjectType,
    campaign_id?: string, 
    campaign?: Campaign,
    filter?: any,
    // force_api?: boolean,
    onComplete?: (res: T[]) => void,
    onProgress?: (data_type: CampaignObjectType, percentage: number) => void,
  }): Promise<T[]> => {
    if (campaign) {
      campaign_id = campaign._id;
    }
    if (this.online && this.user) {
      let data: T[] = [];
      const use_filter = param_filter ? param_filter : { campaign_id };
      if (Object.keys(use_filter).length > 0) {
        // console.log(filter);
        const count = await this.getObjectCountFromAPI({data_type, filter: use_filter });
        const all: any[] = [];
        const piece_size = 200;
        let last_added = -1;
        while (all.length < count.count && last_added !== 0) {
          if (onProgress) {
            onProgress(data_type, all.length / count.count);
          }
          last_added = 0;
          const response = await this.getObjectsFromAPI2({data_type, filter: use_filter, skip: all.length, take: piece_size});
          let body = response;
          if (body && !body.error && !body.message) {
            if (body.objects) {
              body = body.objects;
            }
            for (let i = 0; i < body.length; ++i) {
              const obj = body[i];
              if (all.filter(o => o._id === obj._id).length === 0) {
                all.push(obj);
                last_added++;
              }
            }
            // all = [...all,...body.objects];
          } else {
            console.log(response);
            console.log(body);
          }
        }
        // if (data_type === "character") {
        //   debugger;
        // }
        data = await this.processResponse2<T>({ all, data_type });
        if (campaign) {
          for (const d of data) {
            d.campaign = campaign;
          }
        }
        if (onComplete) {
          onComplete(data);
        }
      }
      return data;
    }
    return [];
  };
  getCampaignObject = async <T extends CampaignObject>({
    data_type,
    campaign_id,
    campaign,
    filter: param_filter,
    onComplete,
    onProgress,
  }: {
    data_type: CampaignObjectType,
    campaign_id?: string,
    campaign?: Campaign,
    filter?: any,
    onComplete?: (res: T) => void,
    onProgress?: (data_type: CampaignObjectType, percentage: number) => void,
  }): Promise<T | undefined> => {
    if (campaign) {
      campaign_id = campaign._id;
    }
    if (campaign_id || param_filter) {
      const objects = await this.getCampaignObjects<T>({ data_type, filter: param_filter, campaign_id, onProgress, campaign });
      if (onComplete) {
        onComplete(objects[0]);
      }
      return objects.length === 1 ? objects[0] : undefined;
    }
    return undefined;
  };
  /**
   * These ones work with the old version of ownership, where owner_id was on PlayerObject.
   */
  getPlayerObjects = async <T extends PlayerObject>({
    data_type,
    filter: param_filter = {}, 
    owner_id = "",
    // force_api = false,
    onComplete,
    onProgress,
  }: {
    data_type: DataType,
    filter?: any, 
    owner_id?: string,
    // force_api?: boolean,
    onComplete?: (res: T[]) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
  }): Promise<T[]> => {
    if (this.online && this.user) {
      let data: T[] = [];
      if (owner_id.length > 0) {
        owner_id = this.user._id; 
      }
      if (Object.keys(param_filter).length === 0) {
        param_filter = { owner_id: this.user._id };
      }
      // console.log(filter);
      const count = await this.getObjectCountFromAPI({data_type, filter: param_filter});
      const all: any[] = [];
      const piece_size = 200;
      let last_added = -1;
      while (all.length < count.count && last_added !== 0) {
        if (onProgress) {
          onProgress(data_type, all.length / count.count);
        }
        last_added = 0;
        const response = await this.getObjectsFromAPI2({data_type, filter: param_filter, skip: all.length, take: piece_size});
        let body = response;
        if (body && !body.error && !body.message) {
          if (body.objects) {
            body = body.objects;
          }
          for (let i = 0; i < body.length; ++i) {
            const obj = body[i];
            if (all.filter(o => o._id === obj._id).length === 0) {
              all.push(obj);
              last_added++;
            }
          }
          // all = [...all,...body.objects];
        } else {
          console.log(response);
          console.log(body);
        }
      }
      // if (data_type === "character") {
      //   debugger;
      // }
      data = await this.processResponse2<T>({ all, data_type });
      if (onComplete) {
        onComplete(data);
      }
      return data;
    } else {
      if (data_type === "character") {
        // Get the characters from cookies
        const items: any = { ...localStorage };
        const char_cookies = Object.keys(items).filter(o => o.startsWith("character_"));
        // console.log(char_cookies);
        const char_ids = char_cookies.map(o => {
          const key = o.replace("character_", "");
          return key;
        }).filter(o => !o.includes("_")); // This will just get the main ones.
        // console.log(char_ids);
        const all: any[] = [];
        for (const char_id of char_ids) {
          const char_obj_str = items[`character_${char_id}`];
          if (char_obj_str) {
            const char_obj = JSON.parse(char_obj_str);
            if (char_obj && char_obj.body) {
              // console.log(char_obj);
              all.push(char_obj.body);
            }
          }
        }
        const data = await this.processResponse2<T>({ all, data_type });
        if (onComplete) {
          onComplete(data);
        }
        return data;
      }
      return [];
    }
  };
  getPlayerObject = async <T extends PlayerObject>({
    data_type,
    id,
    auth_id,
    filter: param_filter,
    email,
    onComplete,
    onProgress,
  }: {
    data_type: DataType,
    id?: string,
    auth_id?: string,
    filter?: any,
    email?: string,
    onComplete?: (res: T) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
  }): Promise<T | undefined> => {
    if (id || auth_id || email) {
      const use_filter = param_filter ? param_filter : (id ? { "_id*ObjectIDs": [id] } : (auth_id ? { "auth_id": auth_id } : { "email": email }));
      const objects = await this.getPlayerObjects<T>({ data_type, filter: use_filter, onProgress });
      if (onComplete) {
        onComplete(objects[0]);
      }
      return objects.length === 1 ? objects[0] : undefined;
    }
    return undefined;
  };

  // Get Standard Objects
  getSetOfObjectsWithCallbacks = async ({ 
    data_types, 
    filter = {}, 
    filters = {}, 
    refresh = false,
    force_api = false,
    force_json = false,
    onComplete,
    onProgress,
    onError,
    archives = [],
    load_all,
    log_it = false
  }: { 
    data_types: DataType[], 
    filter?: any, 
    filters?: any, 
    refresh?: boolean,
    force_api?: boolean,
    force_json?: boolean,
    onComplete?: (res: SmartHash) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
    onError?: Function,
    archives?: string[],
    load_all?: boolean,
    log_it?: boolean
  }) => {
    const return_me: SmartHash = {};
    let data_type: DataType | "" = "";
    try {
      if (log_it) {
        console.log(data_types);
        debugger;
      }
      for (let i = 0; i < data_types.length; i++) {
        data_type = data_types[i];
        // console.log(data_type);
        let the_filter = filters[data_type];
        if (!the_filter) {
          the_filter = filter;
        }
        // if (data_type === "template") {
        //   debugger;
        // }
        if (onProgress) {
          onProgress(data_type, 0);
        }
         
        const onProgress2 = (dt: DataType, percentage: number) => {
          if (onProgress) {
            onProgress(dt, percentage);
          }
        };
        if (data_type === "source_book") {
          return_me.source_book = await this.getSourceBooks({ 
            filter: the_filter, refresh,
            onProgress: onProgress2 
          });
        } else {
          return_me[data_type] = await this.getObjectsWithCallbacks({ 
            data_type,  
            filter: the_filter, refresh, force_api, force_json,
            archives,
            onProgress: onProgress2,
            load_all
          });
        }
      }
      // console.log("Hi");
      if (onComplete) {
        onComplete(return_me);
      }
    } catch (ex) {
      console.log(this.system);
      console.log(data_type);
      console.error(ex);
      if (onError) {
        onError(`Error while loading ${data_type}`);
      }
      debugger;
    }
    return return_me;
  };
  getObjectsWithCallbacks = async <T extends UpsertableBase>({
    data_type, 
    filter = {}, 
    refresh = false,
    force_api = false,
    force_json = false,
    onComplete,
    onProgress,
    // onError,
    archives = [],
    // character_options,
    log_it = false,
    load_all
  }: {
    data_type: DataType, 
    filter?: any, 
    refresh?: boolean,
    force_api?: boolean,
    force_json?: boolean,
    onComplete?: (res: T[]) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
    onError?: Function,
    archives?: string[],
    // character_options?: CharacterOptions,
    log_it?: boolean,
    load_all?: boolean
  }): Promise<T[]> => {
    if (this.user && this.user.admin) { // this.user.is_admin
      console.log(`getObjectsWithCallbacks("${data_type}",${JSON.stringify(filter)}) at ${common_util.get_time_number()}`);
    }
    if (log_it) {
      debugger;
    }
    // if (data_type === "optional_feature_base") {
    //   debugger;
    // }
    let response: UpsertableBase[] = [];
    if (this.alwaysStore(data_type)) {
      if (refresh) {
        delete this.smart_hash[data_type];
      }
      if (!this.smart_hash[data_type]) {
        if (!this.calling.includes(data_type)) {
          this.calling.push(data_type);
          await this.getObjectsFromAPIWithCallbacks({ 
            data_type, 
            force_api, force_json,
            onProgress, log_it
          });
          this.calling = this.calling.filter(o => o !== data_type);
        } else {
          while (this.calling.includes(data_type)) {
            // console.log(`Waiting for ${data_type}`);
            await delay(1000);
          }
          // console.log(this.smart_hash[data_type]);
        }
      }
      if (this.smart_hash[data_type]) {
        response = [...this.smart_hash[data_type]];
      }
    } else if (this.otherStore(data_type)) {
      // For these the filter will always include parent_id.
      if (Object.keys(filter).includes("parent_id")) {
        const parent_id = filter.parent_id;
        if (typeof(parent_id) === "string") {
          const data = this.other_hash.getData(data_type, parent_id);
          response = [...data];
        }
        if (response.length === 0) {
          // It hasn't been loaded into memory yet, so let's get it.
          // We don't want to use the stuff below because that gets all of them, 
          // and we only want to get the ones that match the filter.
          if (this.online) {
            response = await this.getObjectsFromAPIWithCallbacks({ 
              data_type, filter,
              force_api: true, // These are never stored in json. This will bypass unnecessary things
              onProgress, log_it
            });
          }
        }
      }
    } else if (this.use_temp_hash) {
      if (refresh) {
        delete this.temp_hash[data_type];
      }
      if (!this.temp_hash[data_type]) {
        if (!this.calling.includes(data_type)) {
          this.calling.push(data_type);
          await this.getObjectsFromAPIWithCallbacks({ 
            data_type, 
            force_api, force_json,
            onProgress, log_it
          });
          this.calling = this.calling.filter(o => o !== data_type);
        } else {
          while (!this.calling.includes(data_type)) {
            await delay(1000);
          }
        }
      }
      if (this.temp_hash[data_type]) {
        response = [...this.temp_hash[data_type].objects];
      }
    } 
    if (this.online) {
      if (response.length === 0) {
        response = await this.getObjectsFromAPIWithCallbacks({ 
          data_type, 
          force_api, force_json,
          onProgress, log_it
        });
      }

      if (archives.length > 0) {
        const include_archived: ModelBase[] = [];
        if (log_it) {
          debugger;
        }
        for (const archived_sb_id of archives) {
          const response3 = await this.getObjectsFromAPIWithCallbacks({ 
            data_type, 
            force_api, force_json, archived_sb_id,
            onProgress, log_it
          });
          include_archived.push(...response3);
        }
        response.push(...include_archived);
      }
    }
    if (filter && Object.keys(filter).length > 0) {
      response = this.filter(data_type, response, filter) as ModelBase[];
    }
    if (!this.user || !(this.user.view_blocked_source_books || this.user.admin)) {
      response = (response as ModelBase[]).filter(o => !o.blocked);
    }
    if (onComplete) {
      onComplete(response as T[]);
    }
    return response as T[];
  };
  getObjectsFromAPIWithCallbacks = async ({
    data_type, 
    // source_book_ids,
    filter = {}, 
    force_api = false,
    force_json = false,
    onComplete,
    onProgress,
    // onError,
    archived_sb_id = "",
    // character_options,
    log_it = false,
  }: {
    data_type: DataType, 
    // source_book_ids: string[],
    filter?: any, 
    force_api?: boolean,
    force_json?: boolean,
    onComplete?: (res: ModelBase[]) => void,
    onProgress?: (data_type: DataType, percentage: number) => void,
    // onError?: Function,
    archived_sb_id?: string,
    // character_options?: CharacterOptions,
    log_it?: boolean
  }) => {
    // if (data_type === "subclass") {
    //   debugger;
    // }
    if (!isDataType(data_type)) {
      debugger;
      return [];
    }
    const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
    if (dt_info && dt_info.depends_on_data_types) {
      for (const depends_on of dt_info.depends_on_data_types) {
        await this.getObjectsFromAPIWithCallbacks({ data_type: depends_on, force_api, force_json, archived_sb_id });
      }
    }
    let data: ModelBase[] = [];
    let json_successful = false;
    if (archived_sb_id === "") {
      // const filter: any = { };
      if (force_json || 
        ((!this.user || !this.user.admin || TRUST_JSON_FOR_DATA_TYPES.includes(data_type)) && 
          !force_api && this.try_json(data_type))) {
        if (!isPlayerObjectType(data_type)) {
          const new_objects = await this.readJson(data_type);
          if (new_objects) {
            json_successful = true;
            for (const obj of new_objects) {
              if (data_type === "floating_feature" || data_type === "creature_feature") {
                obj.source_books = [{ type: "Source Book", id: "63cd69a14d337b1738dab548", third_party: false }];
              } else if (!obj.source_books || obj.source_books.length === 0) {
                obj.source_books = [{ id: "Personal", type: "Homebrew" }];
              }
            }
            if (log_it) {
              debugger;
            }
            data = await this.processResponse2({ all: new_objects, data_type }) as ModelBase[];
            if (log_it) {
              debugger;
            }
            // data = this.filter(data_type, data, filter); // , data_type === "creature");
            data = data.filter(o => o.source_books_old.filter(o2 => o2.type === "Homebrew").length === 0);
          }
        }
      }
      if (this.online) {
        if (data_type === "source_book" || data_type === "sb_section") {

        } else if (data_type === "floating_feature" || data_type === "creature_feature") {

        } else if (data_type === "template") {

        } else if (data_type === "user") {

        } else if (isPlayerObjectType(data_type)) {
          debugger; // I don't think it should ever come here
        } else {

          // Filter it to only unarchived source_book content.
          if (this.smart_hash.source_book) {
            const unarchived = (this.smart_hash.source_book as SourceBook[]).filter(o => !o.archived);
            filter["source_books.id"] = { "$in": unarchived.map(o => o._id) };
          }
        }
        if (!json_successful || data.length === 0) {
          const count = await this.getObjectCountFromAPI({data_type, filter});
          const piece_size = data_type === "floating_feature" || data_type === "creature_feature" ? 50 : ["spell","creature","game_class","special_feature"].includes(data_type) ? 20 : 100;

          const total_pages = Math.ceil(count.count / piece_size);
          const pages = Array.from({ length: total_pages }, (_, i) => i);

          const all_responses = await batchPromises(
            pages,
            5, // Fetch 5 pages at a time
            page_num => this.getObjectsFromAPI2({
              data_type, 
              filter, 
              skip: page_num * piece_size, 
              take: piece_size
            }),
            (completedPages, totalPages) => {
              if (onProgress) {
                // Calculate estimated records based on completed pages
                const estimated_records = completedPages * piece_size;
                onProgress(data_type, Math.min(estimated_records / count.count, 1));
              }
            }
          );

          // Rest of your code for processing responses...
          const new_objects: any[] = [];
          const seen_ids = new Set<string>();

          for (const response of all_responses) {
            let body = response;
            if (body && !body.error && !body.message) {
              if (body.objects) {
                body = body.objects;
              }
              for (const obj of body) {
                if (!seen_ids.has(obj._id)) {
                  new_objects.push(obj);
                  seen_ids.add(obj._id);
                }
              }
            } else {
              console.log(response);
              console.log(body);
            }
          }

          // Final progress update with actual count
          if (onProgress) {
            onProgress(data_type, 1); // 100% complete
          }
          data = await this.processResponse2({ all: new_objects, data_type }) as ModelBase[]; // , archives
        }
        if (this.user && !this.user.admin && !["floating_feature","creature_feature","user"].includes(data_type)) {
          const newFilter: any = {...filter};
          const sand: any[] = [];
          const no_sb: any = {};
          const hb: any = {};
          no_sb["source_books"] = { "$size": 0 };
          hb["source_books.type"] = "Homebrew";
          sand.push({ "$or": [no_sb, hb] });
          if (!this.user.is_admin) {
            const owner_id: any = {};
            const sb_ids: any = {};
            owner_id["owner_id"] = this.user._id;
            sb_ids["source_books.id"] = { "$in": this.user.source_book_ids };
            sand.push({ "$or": [owner_id, sb_ids] });
          }
          newFilter["$and"] = sand;
          const count = await this.getObjectCountFromAPI({data_type, filter: newFilter});
          let new_objects: any[] = [];
          const piece_size = 200;
          let last_added = -1;
          while (new_objects.length < count.count && last_added !== 0) {
            if (onProgress) {
              onProgress(data_type, new_objects.length / count.count);
            }
            last_added = 0;
            const response = await this.getObjectsFromAPI2({data_type, filter: newFilter, skip: new_objects.length, take: piece_size});
            let body = response;
            if (body && !body.error && !body.message) {
              if (body.objects) {
                body = body.objects;
              }
              for (let i = 0; i < body.length; ++i) {
                const obj = body[i];
                if (new_objects.filter(o => o._id === obj._id).length === 0) {
                  new_objects.push(obj);
                  last_added++;
                }
              }
            } else {
              console.log(response);
              console.log(body);
            }
          }
          const data_ids = data.map(o => o._id);
          new_objects = new_objects.filter(o => !data_ids.includes(o._id));
          for (const obj of new_objects) {
            if (!obj.source_books || obj.source_books.length === 0) {
              obj.source_books = [{ id: "Personal", type: "Homebrew" }];
            }
          }
          if (this.alwaysStore(data_type)) {
            data = await this.processResponse2({ all: new_objects, data_type, merge_hash: true }) as ModelBase[];
          } else {
            const newData = await this.processResponse2({ all: new_objects, data_type, merge_hash: true }) as ModelBase[];
            data = [...data,...newData.filter(o => data.filter(o2 => o2._id === o._id).length === 0)];
          }
        }
      }
    } else {
      const filter = { "source_books.id": archived_sb_id };
      const count = await this.getObjectCountFromAPI({data_type, filter});
      const new_objects: any[] = [];
      const piece_size = ["spell","creature","floating_feature","creature_feature","game_class","special_feature"].includes(data_type) ? 20 : 100
      let last_added = -1;
      while (new_objects.length < count.count && last_added !== 0) {
        if (onProgress) {
          onProgress(data_type, new_objects.length / count.count);
        }
        last_added = 0;
        const response = await this.getObjectsFromAPI2({data_type, filter, skip: new_objects.length, take: piece_size});
        let body = response;
        if (body && !body.error && !body.message) {
          if (body.objects) {
            body = body.objects;
          }
          for (let i = 0; i < body.length; ++i) {
            const obj = body[i];
            if (new_objects.filter(o => o._id === obj._id).length === 0) {
              new_objects.push(obj);
              last_added++;
            }
          }
        } else {
          console.log(response);
          console.log(body);
        }
      }
      data = await this.processResponse2({ all: new_objects, data_type, archived_sb_id }) as ModelBase[]; // , archives
    }
    if (onComplete) {
      onComplete(data);
    }
    return data;
  };
  getSetOfObjects = async ({
    data_types, 
    filter = {}, 
    filters = {}, 
    refresh = false,
    // eslint-disable-next-line
    include_templates = false,
    // eslint-disable-next-line
    character_options,
    archives = [],
    // eslint-disable-next-line
    log_it,
    load_all,
  }: {
    data_types: DataType[], 
    filter?: any, 
    filters?: any, 
    refresh?: boolean,
    include_templates?: boolean,
    character_options?: CharacterOptions,
    archives?: string[],
    log_it?: boolean,
    load_all?: boolean
  }) => {
    const return_me: SmartHash = {};
    for (let i = 0; i < data_types.length; i++) {
      const data_type = data_types[i];
      if (!isDataType(data_type)) {
        debugger;
        continue;
      }
      let the_filter = filters[data_type];
      if (!the_filter) {
        the_filter = filter;
      }
      const data = await this.getObjects({ data_type, filter: the_filter, refresh, archives, load_all }) as ModelBase[]; // , character_options, log_it
      return_me[data_type] = data;
    }
    return return_me;
  };
  getObjectsWithVersions = async ({
    data_type, 
    filter = {}, 
  }: {
    data_type: DataType, 
    filter?: any, 
  }) => {
    let all: ModelBase[] = await this.getObjectsOld(data_type, filter) as ModelBase[];
    let new_data: ModelBase[] = [...all];
    while (new_data.length > 0) {
      const variant_filter = { variant_of_id: { "$in": new_data.map(o => o._id) }};
      new_data = await this.getObjectsOld(data_type, variant_filter) as ModelBase[];
      all = [...all,...new_data];
    }
    return all;
  };

  // Get Any Objects
  getObjectsOld = async (data_type: DataType, 
    filter: any = {}, 
    refresh = false
  ) => {
    return await this.getObjects({ data_type, filter, refresh });
  };
  getObjects = async <T extends UpsertableBase>({
    data_type, 
    filter = {}, 
    refresh = false,
    ignore_templates = true,
    archives,
    log_it = false,
    character_options,
    load_all
  }: {
    data_type: DataType, 
    filter?: any, 
    refresh?: boolean, 
    ignore_templates?: boolean,
    archives?: string[],
    log_it?: boolean,
    character_options?: CharacterOptions,
    load_all?: boolean
  }): Promise<T[]> => {
    // const user = this.user;
    if (log_it) {
      debugger;
    }
    if (CONSTANTIZED_DATA_TYPES.includes(data_type)) {
      let data: UpsertableBase[] = [];
      switch (data_type) {
        case "action_type": data = ACTION_TYPES; break;
        case "armor_type": data = ARMOR_TYPES; break;
        case "language": data = LANGUAGES; break;
        case "sense": data = SENSES; break;
        case "skill": data = SKILLS; break;
        case "weapon_keyword": data = WEAPON_KEYWORDS; break;
      }
      if (Object.keys(filter).length > 0) {
        data = this.filter(data_type, data, filter);
      }
      return data as T[];
    } else if (isPlayerObjectType(data_type)) {
      return (await this.getPlayerObjects({ data_type, filter }) as UpsertableBase[]) as T[];
    } else if (data_type === "source_book") {
      return (await this.getSourceBooks({ filter, log_it }) as UpsertableBase[]) as T[];
    } else if (data_type === "user") {
      return await this.getObjectsWithCallbacks<T>({ data_type, filter, log_it });
    } else {
      if (character_options && character_options.allow_archives) {
        const data = await this.getObjectsWithCallbacks<T>({ data_type, filter, refresh, load_all }); // , archives, character_options
        const archived_sb_ids = this.smart_hash.source_book.filter(o => character_options.source_books.includes(o._id) && o.archived).map(o => o._id);
        if (archived_sb_ids.length > 0) {
          const archived_data = await this.getObjectsWithCallbacks<T>({ data_type, filter, archives: archived_sb_ids, refresh, load_all });
          data.push(...archived_data);
        }
        if (ignore_templates && data.length > 0 && data[0] instanceof ModelBase) {
          return (((data as UpsertableBase[]) as ModelBase[]).filter(o => !o.template_only) as UpsertableBase[]) as T[];
        }
        return data;
      } else {
        const data = await this.getObjectsWithCallbacks<T>({ data_type, filter, archives, refresh, log_it, load_all }); // , archives, character_options
        if (ignore_templates && data.length > 0 && data[0] instanceof ModelBase) {
          return (((data as UpsertableBase[]) as ModelBase[]).filter(o => !o.template_only) as UpsertableBase[]) as T[];
        }
        return data;
      }
    }
  }

  getConstantizedObjects = ({
    data_type, 
    filter = {}, 
  }: {
    data_type: DataType, 
    filter?: any, 
  }) => {
    let data: ModelBase[] = [];
    switch (data_type) {
      case "action_type": data = ACTION_TYPES; break;
      case "armor_type": data = ARMOR_TYPES; break;
      case "language": data = LANGUAGES; break;
      case "sense": data = SENSES; break;
      case "skill": data = SKILLS; break;
      case "weapon_keyword": data = WEAPON_KEYWORDS; break;
    }
    if (Object.keys(filter).length > 0) {
      data = this.filter(data_type, data, filter);
    }
    return data;
  }

  getObjectsFromAPI2 = async ({data_type, filter = {}, skip = 0, take = -1}: {data_type: DataType, filter?: any, skip?: number, take?: number}) => {
    const response = await postData({
      system: this.system,
      path: `/getObjects/${data_type}`, 
      data: { filter, skip, take }
    });
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return [];
    } else {
      return response;
    }
  };

  getObjectFromAPI = async <T extends UpsertableBase>(
    { data_type, id }: 
    { data_type: DataType, id: string }
  ): Promise<T | null> => {
    if (id !== "") {
      const time_number = common_util.get_time_number();
      const response = await getData({
        system: this.system,
        path: `/getObject/${data_type}/${id}/${time_number}`
      });
      if (typeof(response) === "string" && response === "Offline") {
        this.online = false;
      } else {
        const res = await this.processResponse<T>({ response, data_type, sessionName: data_type });
        if (res.res) {
          return res.res;
        }
      }
    } else {
      console.error("Trying to get object with no id");
    }
    return null;
  };
  getFullObject = async <T extends UpsertableBase>(data_type: DataType, id: string, refresh = false): Promise<T | undefined> => {
    return this.getFullObject2({ data_type, id, refresh });
  };
  getFullObject2 = async <T extends UpsertableBase>({ data_type, id, refresh = false, log_it, filter }: 
    { data_type: DataType, id?: string, refresh?: boolean, log_it?: boolean, filter?: any }): Promise<T | undefined> => {
    // if (data_type === "spell") {
    //   debugger;
    // }
    if (log_it) {
      debugger;
    }
    if (this.otherStore(data_type)) {
      try {
        if (id) {
          const obj = await this.getObjectFromAPI<T>({data_type, id}); 
          if (obj) {
            return this.connectObject<T>(obj); 
          }
        } else if (filter) {
          const objects = await this.getObjectsWithCallbacks<T>({ data_type, filter, refresh });
          const obj = objects[0];
          if (obj) {
            return await this.connectObject<T>(obj);
          }
        }
      } catch (ex) {
        console.error(ex);
      }
    } else {
      const objects = await this.getObjectsWithCallbacks<T>({ data_type, refresh });
      const obj = objects.find(o => o._id === id);
      if (obj) {
        return await this.connectObject<T>(obj);
      } else if (this.online) {
        // It's probably Archived
        // This gets it regardless of whether it's archived.  
        // Prefer to use the other one because it uses hashes
        try {
          if (id) {
            const obj = await this.getObjectFromAPI<T>({data_type, id}); 
            if (obj) {
              return this.connectObject<T>(obj); 
            }
          } else if (filter) {
            const objects = await this.getObjectsWithCallbacks<T>({ data_type, filter, refresh });
            const obj = objects[0];
            if (obj) {
              return await this.connectObject<T>(obj);
            }
          }
        } catch (ex) {
          console.error(ex);
        }
      }
    }
    return undefined;
  };
  getObjectCount = async (data_type: DataType, filter: any = {}, refresh = false) => {
    if (refresh) {
      return this.getObjectCountFromAPI({data_type, filter});
    } else {
      if (this.smart_hash[data_type]) {
        const filtered = this.filter(data_type, [...this.smart_hash[data_type]], filter);
        return { count: filtered.length};
      } else {
        return this.getObjectCountFromAPI({data_type, filter});
      }
    }
  };
  getObjectCountFromAPI = async ({data_type, filter = {}}: {data_type: DataType, filter?: any}) => {
    const response = await postData({
      system: this.system,
      path: `/getObjectCount/${data_type}`, 
      data: { filter }
    });
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return -1;
    } else {
      return response;
    }
  };
  getObjectFieldValues = async (data_type: DataType, field: string, filter: any = {}, refresh = false) => {
    if (refresh) {
      return this.getObjectFieldValuesFromAPI(data_type, field, filter);
    } else {
      if (this.smart_hash[data_type]) {
        let found: string[] = [];
        const filtered = this.filter(data_type, [...this.smart_hash[data_type]], filter);

        if (filtered.length > 0) {
          const field_value = (filtered[0] as any)[field];
          if (typeof(field_value) === "object" && field_value.length !== undefined) {
            // It's an array, so we want to get all the values of the array
            found = common_util.unique_array(filtered.flatMap(o => (o as any)[field]));
          } else {
            found = common_util.unique_array(filtered.map(o => (o as any)[field]));
          }
        }
        return found;
      } else {
        return this.getObjectFieldValuesFromAPI(data_type, field, filter);
      }
    }
  };
  getObjectFieldValuesForDataTypes = async (data_types: DataType[], field: string, filter: any = {}, refresh = false) => {
    let all: string[] = [];
    if (refresh) {
      for (const data_type of data_types) {
        const data = await this.getObjectFieldValuesFromAPI(data_type, field, filter);
        all = [...all,...data];
      }
    } else {
      for (const data_type of data_types) {
        if (this.smart_hash[data_type]) {
          let found: string[] = [];
          const filtered = this.filter(data_type, [...this.smart_hash[data_type]], filter);

          if (filtered.length > 0) {
            const field_value = (filtered[0] as any)[field];
            if (typeof(field_value) === "object" && field_value.length !== undefined) {
              // It's an array, so we want to get all the values of the array
              found = common_util.unique_array(filtered.flatMap(o => (o as any)[field]));
            } else {
              found = common_util.unique_array(filtered.map(o => (o as any)[field]));
            }
          }
          all = [...all,...found];
        } else {
          const data = await this.getObjectFieldValuesFromAPI(data_type, field, filter);
          all = [...all,...data];
        }
      }
    }
    return common_util.unique_array(all).filter(o => o !== null && o !== undefined);
  };
  getObjectFieldValuesFromAPI = async (data_type: DataType, field: string, filter: any = {}) => {
    const response = await postData({
      system: this.system,
      path: `/getObjectFieldValues/${data_type}`, 
      data: { field, filter }
    });
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return [];
    } else {
      const body = response; // await response.json();
      let filtered = body.values as any[];
      let found: string[] = [];
      if (filtered.length > 0) {
        const field_value = filtered[0] as any;
        if (typeof(field_value) === "object" && field_value.length) {
          // It's an array, so we want to get all the values of the array
          // Only supported for arrays of strings
          while (filtered.length > 0) {
            const arr_value = (filtered[0] as any)[field];
            
            for (const row of arr_value) {
              if (!found.includes(row)) {
                found.push(field_value);
              }
            }
             
            filtered = filtered.filter(o => !common_util.list1ContainsList2(found, o));
          }
        } else {
          found = filtered;
        }
      }
      return found;
    }
  };
  knockKnock = async (
    { auth_id, email }: 
    { auth_id?: string, email?: string }
  ): Promise<User | null> => {
    const response = await postData({
      system: this.system,
      path: `/knockKnock`,
      data: { auth_id, email }
    });
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
    } else {
      const res = await this.processResponse<User>({ response, data_type: "user" });
      if (res.res) {
        return res.res;
      }
    }
    return null;
  };
  
  filter = (data_type: string, objects: any[], the_filter: any, log_it = false) => {
    // if (log_it) {
    //   debugger;
    // }
    return filter(data_type, objects, the_filter, log_it);
  };

  abstract connectObject<T extends UpsertableBase>(obj: UpsertableBase): Promise<T>;
  // connectObject = async <T extends ModelBase>(obj: ModelBase) => {
  //   if (obj instanceof FeatureSource && !obj.loaded) {
  //     const feature_source = obj as FeatureSource;
  //     for (const fb of feature_source.feature_bases) {
  //       const f_finder = fb.features.filter(o => o.floating_feature_id !== "");
  //       for (const f of f_finder) {
  //         f.floating_feature = this.get_floating_feature(f.floating_feature_id);
  //         f.floating_feature_id = f.floating_feature ? f.floating_feature._id : f.floating_feature_id;
  //       }
  //     }
  //   }
  //   obj.loaded = true;
  //   return obj as T;
  // };

  // eslint-disable-next-line
  handleModelBases = async (all: any[], data_type: DataType, check_hash = false) => {
    return [] as ModelBase[];
  };

  /**
   * This one is only on upsert
   * @param obj 
   * @param data_type 
   */
  handleVersion = async (obj: ModelBase, data_type: DataType) => {
    // if (obj.name.includes("Acid Splash")) {
    //   debugger;
    // }
    if (obj.variant_of_id !== "") {
      let all_variants: ModelBase[] = [];
      if (this.alwaysStore(data_type)) {
        all_variants = (this.smart_hash[data_type] as ModelBase[]).filter(o => o.variant_group_id === obj.variant_group_id);
      } else if (this.otherStore(data_type)) {
        // No versions for these
      } else if (this.use_temp_hash) {
        if (this.temp_hash[data_type]) {
          all_variants = (this.temp_hash[data_type].objects as ModelBase[]).filter(o => o.variant_group_id === obj.variant_group_id);
        }
      }
      all_variants.push(obj);
      for (const variant of all_variants) {
        await this.handleVersion2(variant, all_variants);
      }
    }
  }

  handleVersion2 = async (obj: ModelBase, model_bases: ModelBase[], check_hash = false) => {
    // if (obj.data_type === "tool") {
    //   console.log(obj);
    // }
    const use_model_bases = [...model_bases];
    if (check_hash) {
      const data_type = obj.data_type;
      let add_us: ModelBase[] = [];
      if (this.alwaysStore(data_type)) {
        if (this.smart_hash[data_type]) {
          add_us = this.smart_hash[data_type];
        }
      } else if (this.otherStore(data_type)) {
        // No versions for these
      } else if (this.use_temp_hash && this.temp_hash[data_type]) {
        add_us = this.temp_hash[data_type].objects;
      }
      add_us = add_us.filter(o => o.variant_group_id === obj.variant_group_id);
      use_model_bases.push(...add_us);
    }
    const all_variants = use_model_bases.filter(o => o.variant_group_id === obj.variant_group_id);
    if (all_variants.length > 0) { 
      obj.variant_group = all_variants;
      obj.variant_ids = common_util.unique_array([...obj.variant_ids,...all_variants.map(o => o._id)]); // We don't want to lose the ones not here because they might be archived.
      
      if (obj.source_book_ids.includes("63cd69a14d337b1738dab548")) { // SRD 5.1
        // If it's part of SRD 5.1, check to see if there's a variant on SRD 5.2.1 and both PHBs, and if there's not then add it to that as well.
        if (!obj.source_book_ids.includes("695ae0f0cfa83df9124cb5ac") && 
          !all_variants.some(o => o.source_book_ids.includes("695ae0f0cfa83df9124cb5ac"))
        ) { // SRD 5.2.1
          const sb = this.source_books.find(o => o._id === "695ae0f0cfa83df9124cb5ac");
          if (sb) {
            obj.source_books_old.push({ type: "Source Book", id: "695ae0f0cfa83df9124cb5ac", third_party: false });
            obj.source_books.push(sb);
          }
        }
        if (!obj.source_book_ids.includes("60a9c9ed891e971c782a76a1") && 
          !all_variants.some(o => o.source_book_ids.includes("60a9c9ed891e971c782a76a1"))
        ) { // PHB 5e
          const sb = this.source_books.find(o => o._id === "60a9c9ed891e971c782a76a1");
          if (sb) {
            obj.source_books_old.push({ type: "Source Book", id: "60a9c9ed891e971c782a76a1", third_party: false });
            obj.source_books.push(sb);
          }
        }
        if (!obj.source_book_ids.includes("6675b302a4476741138fa22b") && 
          !all_variants.some(o => o.source_book_ids.includes("6675b302a4476741138fa22b"))
        ) { // PHB 5.5e
          const sb = this.source_books.find(o => o._id === "6675b302a4476741138fa22b");
          if (sb) {
            obj.source_books_old.push({ type: "Source Book", id: "6675b302a4476741138fa22b", third_party: false });
            obj.source_books.push(sb);
          }
        }
      }
    }
    if (obj.variant_ids.length > 0 && 
      this.smart_hash[obj.data_type] && this.smart_hash[obj.data_type].length > 0) {
      // Remove versions that aren't actually versions.
      const non_variant_ids = this.smart_hash[obj.data_type].filter(o => 
        obj.variant_ids.includes(o._id) &&
        o.variant_group_id !== obj.variant_group_id).map(o => o._id);
      obj.variant_ids = obj.variant_ids.filter(o => !non_variant_ids.includes(o));
    }
    
    if (obj.source_book_ids.length > 0) {
      if (!this.smart_hash.source_book) {
        // debugger;
        await this.getObjects({ data_type: "source_book" });
      }
      const source_book = (this.smart_hash.source_book as SourceBook[]).filter(o => o._id === obj.source_book_ids[0])[0];
      if (source_book) {
        obj.source_book_abbrev = source_book.abbreviation;
      }
    }
  }

  createObject = async (data_type: DataType, obj: UpsertableBase) => {
    const response = await postData({ 
      system: this.system, 
      path: "/createObject", 
      data: { data_type, obj: obj.toDBObj() }
    });
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return null;
    } else {
      const res = await this.processResponse({ response, data_type });
      if (res.body.id) {
        obj._id = res.body.id;
        if (this.alwaysStore(data_type)) {
          if (Object.keys(this.smart_hash).includes(data_type)) {
            // if (!this.smart_hash[data_type]) {
            //   this.smart_hash[data_type] = [];
            // }
            if (obj instanceof ModelBase) {
              this.handleVersion(obj, data_type);
            }
            switch(data_type) {
              // case "spell":
              //   this.smart_hash[data_type].push(obj as Spell);
              // break;
              // case "skill":
              //   this.smart_hash[data_type].push(obj as Skill);
              // break;
              // case "condition":
              //   this.smart_hash[data_type].push(obj as Condition);
              // break;
              // case "spell_list": 
              //   this.smart_hash[data_type].push(obj as SpellList);
              // break;
              // case "armor_type": 
              //   this.smart_hash[data_type].push(obj as ArmorType);
              // break;
              // case "background": 
              //   this.smart_hash[data_type].push(obj as Background);
              // break;
              // case "base_item": 
              //   this.smart_hash[data_type].push(obj as BaseItem);
              // break;
              // case "campaign":
              //   this.smart_hash[data_type].push(obj as Campaign);
              // break;
              // case "character": 
              //   this.smart_hash[data_type].push(obj as Character);
              // break;
              // case "creature": 
              //   this.smart_hash[data_type].push(obj as Creature);
              // break;
              // case "eldritch_invocation": 
              //   this.smart_hash[data_type].push(obj as EldritchInvocation);
              // break;
              // case "fighting_style": 
              //   this.smart_hash[data_type].push(obj as FightingStyle);
              // break;
              // case "equipment_pack": 
              //   this.smart_hash[data_type].push(obj as EquipmentPack);
              // break;
              // case "pact_boon": 
              //   this.smart_hash[data_type].push(obj as PactBoon);
              // break;
              // case "feat": 
              //   this.smart_hash[data_type].push(obj as Feat);
              // break;
              // case "game_class": 
              //   this.smart_hash[data_type].push(obj as GameClass);
              // break;
              // case "organization": 
              //   this.smart_hash[data_type].push(obj as Organization);
              // break;
              // case "org_instance": 
              //   this.smart_hash[data_type].push(obj as OrgInstance);
              // break;
              // case "org_position": 
              //   this.smart_hash[data_type].push(obj as OrgPosition);
              // break;
              // case "magic_item": 
              //   this.smart_hash[data_type].push(obj as IMagicItem);
              // break;
              // case "magic_item_keyword": 
              //   this.smart_hash[data_type].push(obj as MagicItemKeyword);
              // break;
              // case "magic_item_template": 
              // break;
              // case "race": 
              //   this.smart_hash[data_type].push(obj as Race);
              // break;
              // case "subrace": 
              //   this.smart_hash[data_type].push(obj as Subrace);
              // break;
              // case "gift": 
              //   this.smart_hash[data_type].push(obj as Gift);
              // break;
              // case "resource":
              //   this.smart_hash[data_type].push(obj as Resource);
              // break;
              // case "spell_slot_type":
              //   this.smart_hash[data_type].push(obj as SpellSlotType);
              // break;
              // case "subclass":
              //   this.smart_hash[data_type].push(obj as Subclass);
              // break;
              // case "table":
              //   this.smart_hash[data_type].push(obj as Table);
              // break;
              // case "encounter":
              //   this.smart_hash[data_type].push(obj as Encounter);
              // break;
              // case "loot_table":
              //   this.smart_hash[data_type].push(obj as LootTable);
              // break;
              // case "user":
              //   // this.users.push(obj as User);
              // break;
              // case "weapon_keyword":
              //   this.smart_hash[data_type].push(obj as WeaponKeyword);
              // break;
              // case "rollable_table":
              //   this.smart_hash[data_type].push(obj as RollableTable);
              // break;
              // case "template":
              //   this.smart_hash[data_type].push(obj as TemplateBase);
              // break;
              case "floating_feature":
                this.add_floating_feature(obj as FloatingFeature);
              break;
              case "creature_feature":
                this.add_creature_feature(obj as CreatureFeature);
              break;
              case "optional_feature_base":
                this.smart_hash[data_type].push(obj as OptionalFeatureBase);
              break;
              case "source_book":
                this.smart_hash[data_type].push(obj as SourceBook);
              break;
              default:
                if (obj instanceof ModelBase) {
                  this.smart_hash[data_type].push(obj);
                }
              break;
            }
          }
        } else if (this.otherStore(data_type)) {
          if (obj instanceof ParentedBase) {
            this.other_hash.appendData(obj);
          }
        } else if (this.use_temp_hash && this.temp_hash[data_type]) {
          if (obj instanceof ModelBase) {
            this.handleVersion(obj, data_type);
            this.temp_hash[data_type].objects.push(obj);
            this.temp_hash[data_type].last_accessed = common_util.get_time_number();
          }
        }
        if (data_type === "source_book") {
          this.updateFreeSBIDs();
        }
      }
      res.res = obj;
      return res;
    }
  };

  deleteObject = async (data_type: DataType, obj: UpsertableBase) => {
    const object_id = obj._id;
    const response = await deleteData({ 
      system: this.system, 
      path: "/deleteObject", 
      data: { data_type, object_id }
    });
    const res = await this.processResponse({ response, data_type });
    if (res.body.message.includes("deleted!")) {
      if (this.smart_hash[data_type]) {
        this.smart_hash[data_type] = this.smart_hash[data_type].filter(o => o._id !== object_id);
      } else if (this.use_temp_hash && this.temp_hash[data_type]) {
        this.temp_hash[data_type].objects = this.temp_hash[data_type].objects.filter(o => o._id !== object_id);
        this.temp_hash[data_type].last_accessed = common_util.get_time_number();
      }
    }
    return res;
  };

  deleteObjects = async (data_type: DataType, objects: UpsertableBase[]) => {
    const return_me: any[] = [];
    for (let i = 0; i < objects.length; i++) {
      const obj = objects[i];
      return_me.push(await this.deleteObject(data_type, obj));
    }
    return return_me;
  };

  updateObject = async (data_type: DataType, obj: UpsertableBase, property_names?: string[]) => {
    if (obj._id.length > 0) {
      if (obj instanceof ModelBase) {
        if (this.user && this.user.admin && 
          obj.source_books_old.filter(o => o.type === "Homebrew").length === 0 && 
          obj.owner_id !== "") {
          obj.owner_id = "";
        }
        if (this.smart_hash[obj.data_type]) {
          const all_variants = this.smart_hash[obj.data_type].filter(o => o.variant_group_id === obj.variant_group_id);
          obj.variant_group = all_variants;
          obj.variant_ids = common_util.unique_array([...obj.variant_ids,...all_variants.map(o => o._id)]); 
        } else if (this.temp_hash[obj.data_type]) {
          const all_variants = this.temp_hash[obj.data_type].objects.filter(o => o.variant_group_id === obj.variant_group_id);
          obj.variant_group = all_variants;
          obj.variant_ids = common_util.unique_array([...obj.variant_ids,...all_variants.map(o => o._id)]); 
        }
      }
      const response = await patchData({ 
        system: this.system, 
        path: "/updateObject", 
        data: { data_type, obj: obj.toDBObj(), property_names }
      });
      const res = response;
      // debugger;
      if (res.success) {
        if (this.smart_hash[data_type]) {
          const objects = [...this.smart_hash[data_type]];
          const objFinder = objects.find(o => o._id === obj._id);
          if (objFinder) {
            const updated = objFinder;
            if (obj.constructor === updated.constructor) {
              if (obj instanceof ModelBase) {
                this.handleVersion(obj, data_type);
              }
              if (obj instanceof ModelBase && 
                updated instanceof ModelBase) {
                // if (obj instanceof Spell) {
                  // debugger;
                // }
                if (obj !== updated) {
                  updated.copy(obj);
                }
                this.smart_hash[data_type] = objects;
              }
            } else if (obj instanceof ModelBase) {
              // The type has changed.  This generally means it's an issue of inheritance.
              // The best way to handle it would be to remove the old one from cache and replace with the new
              this.smart_hash[data_type] = this.smart_hash[data_type].filter(o => o._id !== obj._id);
              this.smart_hash[data_type].push(obj);
            }
          }
        } else if (this.use_temp_hash) {
          if (this.temp_hash[data_type]) {
            const objects = [...this.temp_hash[data_type].objects];
            const objFinder = objects.find(o => o._id === obj._id);
            if (objFinder) {
              const updated = objFinder;
              if (obj.constructor === updated.constructor) {
                if (obj instanceof ModelBase) {
                  this.handleVersion(obj, data_type);
                }
                if (obj instanceof ModelBase && 
                  updated instanceof ModelBase) {
                  // if (obj instanceof Spell) {
                    // debugger;
                  // }
                  if (obj !== updated) {
                    updated.copy(obj);
                  }
                  this.temp_hash[data_type].objects = objects;
                }
              } else if (obj instanceof ModelBase) {
                // The type has changed.  This generally means it's an issue of inheritance.
                // The best way to handle it would be to remove the old one from cache and replace with the new
                this.temp_hash[data_type].objects = this.temp_hash[data_type].objects.filter(o => o._id !== obj._id);
                this.temp_hash[data_type].objects.push(obj);
              }
            }
            this.temp_hash[data_type].last_accessed = common_util.get_time_number();
          }
        }
        if (data_type === "source_book") {
          this.updateFreeSBIDs();
        }
      } else {
        console.log(res);
      }
      return { body: res, res: obj };
    } else {
      return { body: "Cannot update when _id is empty.", res: obj };
    }
  };

  updateFreeSBIDs = () => {
    // debugger;
    if (this.user && this.smart_hash.source_book) {
      this.user.free_sb_ids = this.source_books.filter(o => o.is_free).map(o => o._id);
    }
  }

  upsertObject = async (data_type: DataType, obj: UpsertableBase) => {
    if (obj._id && obj._id !== "") {
      const res = await this.updateObject(data_type, obj);
      return res;
    } else {
      const res = await this.createObject(data_type, obj);
      return res;
    }
  };

  upsertObjects = async (data_type: DataType, objects: UpsertableBase[]) => {
    const return_me: any[] = [];
    for (let i = 0; i < objects.length; i++) {
      const obj = objects[i];
      return_me.push(await this.upsertObject(data_type, obj));
    }
    return return_me;
  };

  // User Ratings
  getUserRatings = async (data_type: DataType, id: string) => {
    if (this.online) {
      const response = await getData({ 
        system: this.system, 
        path: `/getUserRatings/${data_type}/${id}`
      });
      if (typeof(response) === "string" && response === "Offline") {
        this.online = false;
      } else {
        const data = await this.processUserRatingResponse(response);
        return data.objects;
      }
    }
    return [];
  };
  deleteUserRatings = async (data_type: DataType, obj: FeatureSource) => {
    const object_id = obj._id;
    const response = await deleteData({ 
      system: this.system, 
      path: "/deleteUserRatings", 
      data: { data_type, object_id }
    });
    const res = await this.processResponse({ response, data_type });
    return res;
  };

  alwaysStore(data_type: DataType) { // If it passes this it goes into smart_hash
    if (data_type === "user_ticket") {
      return true;
    }
    const dont_store = ["user","feature_user_rating","sb_section",...PLAYER_OBJECT_TYPES,...OTHER_NON_CACHED_OBJECTS];
    return !dont_store.includes(data_type);
  }
  otherStore(data_type: DataType) { 
    // If it passes this then it shouldn't go into either smart_hash or temp_hash. 
    // Instead it goes into other_hash. other_hash works like smart_hash, but we build it piecemeal.
    // Every time we query for something in it that we don't find, we add it in.
    // It has keys for data_type, and then for the primary key of the query used to get it. 
    // The primary key will always be parent_id, regardless of data_type.
    const dont_store = ["sb_section"];
    return dont_store.includes(data_type);
  }
  try_json(data_type: DataType) {
    const not_in_json = ["user","feature_user_rating","sb_section",...PLAYER_OBJECT_TYPES]; // ,"base_item","magic_item"];
    return !not_in_json.includes(data_type);
  }

  isUpper(str: string) {
    return !/[a-z]/.test(str) && /[A-Z]/.test(str);
  }

  processResponse = async <T extends UpsertableBase>({
    response, 
    data_type, 
    log_it = false
  }: processResponseProps): Promise<{ body: any, res: T | null }> => {
    // log_it = data_type === "creature";
    const body = response; // await response.json();
    if (log_it) {
      console.log(body);
      debugger;
    }
    let my_response: UpsertableBase | null = null;
    if (typeof(body) === "object" && body._id) {
      switch(data_type) {
        case "user":
          {
            const user = new User(body);
            // user.ownerships = await this.getObjects<UserOwnership>({ data_type: "user_ownership", filter: { user_id: user._id }});
            my_response = user;
          }
        break;
        // case "user_ownership":
        //   {
        //     my_response = new UserOwnership(body);
        //   }
        // break;
        case "source_book": 
          my_response = new SourceBook(body);
        break;
      }
    }
    return { body, res: my_response as T };
  };

  processResponseObjects = async <T extends UpsertableBase>({
    response, 
    data_type, 
    log_it = false
  }: processResponseProps) => {
    // log_it = data_type === "creature";
    const body = response; // await response.json();
    if (log_it) {
      console.log(body);
      debugger;
    }
    let my_response: PlayerObject[] | ModelBase[] | User[] = []; // body;
    if (body.objects) {
      switch(data_type) {
        case "user": 
          const users: User[] = [];
          body.objects.forEach((o: any) => {
            users.push(new User(o));
          });
          my_response = users;
        break;
      }
      if (my_response.length > 0 && my_response[0] instanceof ModelBase) {
        // console.log(data_type);
        console.log(my_response);
        this.smart_hash[data_type] = my_response as ModelBase[];
      }
    }
    return { body, res: (my_response as any) as T[] };
  };

  processResponse2 = async <T extends UpsertableBase>({
    all, 
    data_type,
    merge_hash = false,
    // archived_sb_id = "",
    // filtered = false
  }: {
    all: any[], 
    data_type: DataType,
    merge_hash?: boolean,
    archived_sb_id?: string,
    // filtered?: boolean
  }): Promise<T[]> => {
    let response: PlayerObject[] | ModelBase[] | User[] = []; // all;
    // if (data_type === "creature") {
    //   debugger;
    // }
    if (all) {
      switch(data_type) {
        case "user": 
          const users: User[] = [];
          for (const o of all) {
            users.push(new User(o));
          }
          response = users;
        break;
      }
      if (this.alwaysStore(data_type) && data_type !== "floating_feature" && data_type !== "creature_feature") {
        // if (data_type === "condition" && this.smart_hash[data_type]) {
        //   console.log([...this.smart_hash[data_type]]);
        // }
        if (merge_hash) {
          if (this.smart_hash[data_type]) {
            const oldOnes = [...this.smart_hash[data_type]];
            let newOnes = response as ModelBase[];
            newOnes = newOnes.filter(o => oldOnes.filter(o2 => o2._id === o._id).length === 0);
            this.smart_hash[data_type] = [...oldOnes,...newOnes];
            response = this.smart_hash[data_type];
          } else {
            // console.log(response);
            this.smart_hash[data_type] = response as ModelBase[];
          }
        } else {
          // console.log(response);
          this.smart_hash[data_type] = response as ModelBase[];
        }
        // if (data_type === "condition") {
        //   console.log([...this.smart_hash[data_type]]);
        // }
      } else if (this.otherStore(data_type)) {
        if (response.length > 0 && response[0] instanceof ParentedBase) {
          this.other_hash.setData(response as ParentedBase[]);
        }
      } else if (!this.alwaysStore(data_type) && !PLAYER_OBJECT_TYPES.includes(data_type)) {
        if (this.use_temp_hash) {
          if (response.length === 0 && this.temp_hash[data_type] && this.temp_hash[data_type].objects.length > 0) {
            response = this.temp_hash[data_type].objects;
          }
          this.store_to_temp(data_type, response as ModelBase[]);
        }
      }
      if (data_type === "source_book") {
        this.updateFreeSBIDs();
      }
    }
    return (response as any) as T[];
  };
  
  processUserRatingResponse = async (response: any) => {
    const body = await response.json();
    if (response.status !== 200) { 
      throw Error(body.message);
    } else {
      const response: any = body;
      return response;
    }
  };

  fetchData = async ({ path, system = "main", options = {} }: DataCall) => {
    const response = await getData({ path, system, options });
    
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return null;
    } else {
      return response;
    }
  };

  patchData = async ({ path, data, system = "main", options = {} }: DataCall) => {
    const response = await patchData({ path, data, system, options });
    
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return null;
    } else {
      return response;
    }
  };

  postData = async ({ path, data, system = "main", options = {} }: DataCall) => {
    const response = await postData({ path, data, system, options });
    
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return null;
    } else {
      return response;
    }
  };

  uploadData = async ({ path, data, system = "main", options = {} }: DataCall) => {
    const response = await uploadData({ path, data, system, options });
    
    if (typeof(response) === "string" && response === "Offline") {
      this.online = false;
      return null;
    } else {
      return response;
    }
  };

  abstract readJson(data_type: DataType): Promise<any[]>;
}

export interface processResponseProps {
  response: any;
  data_type: DataType;
  retry?: Function | null;
  sessionName?: string | null; 
  noExpiry?: boolean;
  log_it?: boolean;
  check_hash?: boolean;
}

export type RootSubscriptionType = "Reload" | "Post Reload" | "Logout";

export class RootSubscriptionHolder {
  private eventMap: { [subscription_type: string]: Subscription[] } = {};

  private get onReload()        { return this.getOrInit("Reload"); }
  private get onPostReload()        { return this.getOrInit("Post Reload"); }
  private get onLogout()        { return this.getOrInit("Logout"); }

  private getOrInit(key: RootSubscriptionType): Subscription[] {
    if (!this.eventMap[key]) {
      this.eventMap[key] = [];
    }
    return this.eventMap[key];
  }

  reload() {
    this.eventMap.onReload = this.onReload.filter(o => o.ref.current);
    // debugger;
    for (const sub of this.onReload) {
      sub.method("Reload", false);
    }
    // this.anyChanged(); // Not actuall from a change
  }

  postReload() {
    this.eventMap.onPostReload = this.onPostReload.filter(o => o.ref.current);
    // debugger;
    for (const sub of this.onPostReload) {
      sub.method("Reload", false);
    }
    // this.anyChanged(); // Not actuall from a change
  }

  logout() {
    this.eventMap.onLogout = this.onLogout.filter(o => o.ref.current);
    // debugger;
    for (const sub of this.onLogout) {
      sub.method("Logout", false);
    }
  }

  subscribe(to: RootSubscriptionType, ref: React.MutableRefObject<boolean>, method: () => void) {
    const true_id = uuidv4().toString();
    const existing = this.getOrInit(to).find(o => o.ref === ref);
    if (!existing) {
      this.eventMap[to].push({ method, ref, true_id });
    }
    return true_id;
  }
}